import { Box, withStyles, createStyles } from "@material-ui/core";
import { format } from "date-fns";

import { Chip } from "~components/Chip";
import { TransactionTableItem } from "~components/TableRows/Transaction";

import { Cell } from "./Cell";
import { CopyCell } from "./CopyCell";
import { Column } from "./Column";
import { Layout } from "./Layout";
import { StatusWithDate } from "./StatusWithDate";
import { CellAction } from "./CellAction";
import { Separator } from "./Separator";

export type DetailViewItem = TransactionTableItem & {
  completedAt: Date;
  bankResponse: string;
  providerResponse: string;
  payerName: string;
  bic: string;
  iban: string;
  merchantName: string;
  email: string;
  shopperReference: string;
};

export type DetailViewProps<T extends DetailViewItem> = {
  transaction: T;
  onViewMore: () => void;
  onHide: () => void;
  onKibana?: () => void;
  onCloudwatch?: () => void;
};

export const DetailView = <T extends DetailViewItem>({
  onViewMore,
  onHide,
  transaction,
  onKibana,
  onCloudwatch,
}: DetailViewProps<T>) => {
  return (
    <Layout onViewMore={onViewMore} title="Transaction details" onHide={onHide} sticky>
      <Column
        title="Volt data"
        renderRight={() => (
          <StatusWithDate
            date={transaction.completedAt ? format(transaction.completedAt, "dd/MM/yy") : undefined}
            status={transaction?.status}
          />
        )}
      >
        <CopyCell title="Volt ID" value={transaction?.id || ""} />
        <Cell title="Bank Response" value={transaction.bankResponse} />
        <Cell title="Provider Response" value={transaction.providerResponse} />
        <ExternalLinkChips>
          {onKibana ? <Chip label="Kibana" style={{ marginRight: 12 }} onClick={onKibana} /> : null}
          {onCloudwatch ? <Chip label="Cloudwatch" onClick={onCloudwatch} /> : null}
        </ExternalLinkChips>
      </Column>
      <Column title="Payer">
        <Cell title="Name" value={transaction.payerName} />
        <Cell title="BIC/sort code" value={transaction.bic} />
        <Cell title="Iban" value={transaction.iban} />
      </Column>
      <Column title="Merchant Data">
        <Cell title="Name" value={transaction.merchantName} />
        <Cell title="Email" value={transaction.email} />
        <Cell title="Shopper reference" value={transaction.shopperReference} />
        <Cell title="unique reference" value={transaction.uniqueReference} />
      </Column>
    </Layout>
  );
};

const ExternalLinkChips = withStyles((theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(2),
    },
  }),
)(Box);

DetailView.Cell = Cell;
DetailView.CopyCell = CopyCell;
DetailView.Column = Column;
DetailView.Layout = Layout;
DetailView.StatusWithDate = StatusWithDate;
DetailView.ExternalLinkChips = ExternalLinkChips;
DetailView.CellAction = CellAction;
DetailView.Separator = Separator;
